module.exports = __webpack_public_path__ + "img/legend-card2.024da62e.png";